import { createIcon } from '@chakra-ui/react';

export const PendingIcon = createIcon({
  displayName: 'PendingIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '6',
    width: '6',
  },
  path: (
    <path
      d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM12 5C15.8658 5.00026 19 8.13417 19 12C19 15.8658 15.8658 18.9997 12 19C10.067 18.9999 8.31648 18.216 7.0498 16.9492L11.999 12V5H12Z"
      fill="currentColor"
    />
  ),
});
